import React, { useEffect, useState } from "react";
import ScrollToTop from "../components/ScrollToTop";
import Preloader from "../components/Preloader";
import HeroSection from "../components/Home/HeroSection";
import ServiceSection from "../components/Home/ServiceSection";
import AboutSection from "../components/Home/AboutSection";
import TeamMembersSection from "../components/Home/TeamMembersSection";
import WorkProcessSection from "../components/WorkProcessSection";
import TestimonialSection from "../components/Home/TestimonialSection";
import Faq from "./Faq";

function Home() {
  const [homeData, setHomeData] = useState(null);
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAll = async () => {
      try {
        const [homeResponse, aboutResponse] = await Promise.all([
          fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/home/page/"),
          fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/about/page/")
        ]);
        
        const homeData = await homeResponse.json();
        const aboutData = await aboutResponse.json();
        
        setHomeData(homeData);
        setAboutData(aboutData);
      } catch (err) {
        console.error("API ERROR:", err);
      } finally {
        setLoading(false);
      }
    };

    loadAll();
  }, []);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  if (loading) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <div className="spinner-border text-primary" />
          <p className="mt-2">Բեռնվում է...</p>
        </div>
      </div>
    );
  }

  const homePageData = homeData || {};
  const aboutPageData = aboutData || {};
  const workProcess = aboutData?.work_processes || [];
  const teamMembers = aboutData?.team_members || [];
  const testimonials = homeData?.testimonials || [];
  const faqs = homeData?.faqs || [];

  return (
    <div>
      <Preloader />
      <HeroSection data={homePageData} />
      <ServiceSection />
      <AboutSection data={aboutPageData} />
      <WorkProcessSection data={aboutPageData} workProcess={workProcess} />
      <TeamMembersSection data={aboutPageData} team={teamMembers} />
      <TestimonialSection testimonials={testimonials} />
      <ScrollToTop />
      <Faq faqs={faqs} />
    </div>
  );
}

export default Home;